import { DOMAINS } from '@/shared-utilities';

export const apiHost = process.env.NEXT_PUBLIC_API_HOST || DOMAINS.AI_PROD;
export const posthogToken = process.env.NEXT_PUBLIC_POSTHOG || '';
export const posthogApiHost = process.env.NEXT_PUBLIC_POSTHOG_API_HOST || '';
